await import('/var/www/Studio-Frontend/node_modules/@umijs/bundler-webpack/client/client/client.js');
await import('/var/www/Studio-Frontend/src/.umi/umi.ts');
export default 1;